var map = {
	".": 78,
	"./": 78,
	"./Icons/Amazon": 743,
	"./Icons/Amazon.js": 743,
	"./Icons/Amex": 744,
	"./Icons/Amex.js": 744,
	"./Icons/Applepay": 745,
	"./Icons/Applepay.js": 745,
	"./Icons/Aura": 746,
	"./Icons/Aura.js": 746,
	"./Icons/Bb": 747,
	"./Icons/Bb.js": 747,
	"./Icons/Bitcoin": 748,
	"./Icons/Bitcoin.js": 748,
	"./Icons/Boleto": 749,
	"./Icons/Boleto.js": 749,
	"./Icons/Bradesco": 750,
	"./Icons/Bradesco.js": 750,
	"./Icons/Caixa": 751,
	"./Icons/Caixa.js": 751,
	"./Icons/Cielo": 752,
	"./Icons/Cielo.js": 752,
	"./Icons/Cirrus": 753,
	"./Icons/Cirrus.js": 753,
	"./Icons/Diners": 754,
	"./Icons/Diners.js": 754,
	"./Icons/DirectDebit": 755,
	"./Icons/DirectDebit.js": 755,
	"./Icons/Discover": 756,
	"./Icons/Discover.js": 756,
	"./Icons/Ebay": 757,
	"./Icons/Ebay.js": 757,
	"./Icons/Elavon": 758,
	"./Icons/Elavon.js": 758,
	"./Icons/Elo": 759,
	"./Icons/Elo.js": 759,
	"./Icons/Eway": 760,
	"./Icons/Eway.js": 760,
	"./Icons/Generic": 761,
	"./Icons/Generic.js": 761,
	"./Icons/Global": 762,
	"./Icons/Global.js": 762,
	"./Icons/Googlepay": 763,
	"./Icons/Googlepay.js": 763,
	"./Icons/Hsbc": 764,
	"./Icons/Hsbc.js": 764,
	"./Icons/Itau": 765,
	"./Icons/Itau.js": 765,
	"./Icons/Jcb": 766,
	"./Icons/Jcb.js": 766,
	"./Icons/Maestro": 767,
	"./Icons/Maestro.js": 767,
	"./Icons/Mastercard": 768,
	"./Icons/Mastercard.js": 768,
	"./Icons/Pagseguro": 769,
	"./Icons/Pagseguro.js": 769,
	"./Icons/Paypal": 770,
	"./Icons/Paypal.js": 770,
	"./Icons/Rede": 771,
	"./Icons/Rede.js": 771,
	"./Icons/Sage": 772,
	"./Icons/Sage.js": 772,
	"./Icons/Santander": 773,
	"./Icons/Santander.js": 773,
	"./Icons/Shopify": 774,
	"./Icons/Shopify.js": 774,
	"./Icons/Skrill": 775,
	"./Icons/Skrill.js": 775,
	"./Icons/SkrillMoneybookers": 776,
	"./Icons/SkrillMoneybookers.js": 776,
	"./Icons/Solo": 777,
	"./Icons/Solo.js": 777,
	"./Icons/Stone": 778,
	"./Icons/Stone.js": 778,
	"./Icons/Visa": 779,
	"./Icons/Visa.js": 779,
	"./Icons/VisaElectron": 780,
	"./Icons/VisaElectron.js": 780,
	"./Icons/Wallet": 781,
	"./Icons/Wallet.js": 781,
	"./Icons/Western": 782,
	"./Icons/Western.js": 782,
	"./Icons/Worldpay": 783,
	"./Icons/Worldpay.js": 783,
	"./Icons/transparent/AmazonTransparent": 784,
	"./Icons/transparent/AmazonTransparent.js": 784,
	"./Icons/transparent/BbTransparent": 785,
	"./Icons/transparent/BbTransparent.js": 785,
	"./Icons/transparent/BoletoTransparent": 786,
	"./Icons/transparent/BoletoTransparent.js": 786,
	"./Icons/transparent/BradescoTransparent": 787,
	"./Icons/transparent/BradescoTransparent.js": 787,
	"./Icons/transparent/CaixaTransparent": 788,
	"./Icons/transparent/CaixaTransparent.js": 788,
	"./Icons/transparent/CieloTransparent": 789,
	"./Icons/transparent/CieloTransparent.js": 789,
	"./Icons/transparent/ElavonTransparent": 790,
	"./Icons/transparent/ElavonTransparent.js": 790,
	"./Icons/transparent/GenericTransparent": 791,
	"./Icons/transparent/GenericTransparent.js": 791,
	"./Icons/transparent/GlobalTransparent": 792,
	"./Icons/transparent/GlobalTransparent.js": 792,
	"./Icons/transparent/HsbcTransparent": 793,
	"./Icons/transparent/HsbcTransparent.js": 793,
	"./Icons/transparent/ItauTransparent": 794,
	"./Icons/transparent/ItauTransparent.js": 794,
	"./Icons/transparent/PagseguroTransparent": 795,
	"./Icons/transparent/PagseguroTransparent.js": 795,
	"./Icons/transparent/PaypalTransparent": 796,
	"./Icons/transparent/PaypalTransparent.js": 796,
	"./Icons/transparent/RedeTransparent": 797,
	"./Icons/transparent/RedeTransparent.js": 797,
	"./Icons/transparent/SantanderTransparent": 798,
	"./Icons/transparent/SantanderTransparent.js": 798,
	"./Icons/transparent/StoneTransparent": 799,
	"./Icons/transparent/StoneTransparent.js": 799,
	"./Icons/transparent/WalletTransparent": 800,
	"./Icons/transparent/WalletTransparent.js": 800,
	"./Icons/transparent/WorldpayTransparent": 801,
	"./Icons/transparent/WorldpayTransparent.js": 801,
	"./index": 78,
	"./index.js": 78,
	"./remoteImages": 508,
	"./remoteImages.js": 508,
	"./test": 802,
	"./test.js": 802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1377;